"use client";

import { SidebarProvider } from "@/components/ui/sidebar";
import { CentrifugeProvider } from "@/shared/CentrifugeProvider";
import { MediaCallProvider } from "@/src/lib/media-call/MediaCallProvider";
import { I18nRuntimeProvider } from "@/shared/I18nRuntimeProvider";
import { ReduxProvider } from "@/shared/ReduxProvider";
import ConditionalLayout from "@/shared/ConditionalLayout";
import { BrandTitleEffect } from "@/components/BrandTitleEffect";
import { SkipLink } from "@/components/SkipLink";
import { ClientErrorBoundary } from "@/components/ClientErrorBoundary";
import Providers from "./providers";
import type { AbstractIntlMessages } from "next-intl";

type LayoutContentProps = {
  children: React.ReactNode;
  messages: AbstractIntlMessages;
  locale: string;
  showKeysFromServer: boolean;
};

export function LayoutContent({ children, messages, locale, showKeysFromServer }: LayoutContentProps) {
  return (
    <ClientErrorBoundary>
      <I18nRuntimeProvider
        initialLocale={locale}
        initialMessages={messages}
        showKeysFromServer={showKeysFromServer}
      >
        <SkipLink />
        <BrandTitleEffect />
        <ReduxProvider>
          <CentrifugeProvider>
            <Providers>
              <MediaCallProvider>
                <SidebarProvider>
                  <ConditionalLayout>{children}</ConditionalLayout>
                </SidebarProvider>
              </MediaCallProvider>
            </Providers>
          </CentrifugeProvider>
        </ReduxProvider>
      </I18nRuntimeProvider>
    </ClientErrorBoundary>
  );
}
